import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/coming-soon-img.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "licenseRequest" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Coming Soon"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "coming_soon",
    class: "comingSoonImage"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_respond_to_negotiation = _resolveComponent("respond-to-negotiation")!
  const _component_actions_for_request_license = _resolveComponent("actions-for-request-license")!
  const _component_app_page = _resolveComponent("app-page")!

  return (_openBlock(), _createBlock(_component_app_page, {
    config: _ctx.config,
    loading: _ctx.loading
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        (_ctx.showResponseModal)
          ? (_openBlock(), _createBlock(_component_respond_to_negotiation, {
              key: 0,
              show: _ctx.showResponseModal,
              data: _ctx.payLoad,
              "n-offer": _ctx.oferN,
              working: _ctx.controller.requests.responding.value,
              onRespond: _ctx.handleRequestModalResponse
            }, null, 8, ["show", "data", "n-offer", "working", "onRespond"]))
          : _createCommentVNode("", true),
        _createVNode(_component_actions_for_request_license, {
          action: _ctx.showModalActions,
          onCloseActions: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModalActions = '')),
          onCounterOffer: _ctx.counterOffer,
          item: _ctx.payLoad?.item
        }, null, 8, ["action", "onCounterOffer", "item"])
      ])
    ]),
    _: 1
  }, 8, ["config", "loading"]))
}